import { render, staticRenderFns } from "./StyleClassic.vue?vue&type=template&id=4ee09d61&scoped=true"
import script from "./StyleClassic.vue?vue&type=script&lang=js"
export * from "./StyleClassic.vue?vue&type=script&lang=js"
import style0 from "./StyleClassic.vue?vue&type=style&index=0&id=4ee09d61&prod&lang=scss&scoped=true"
import style1 from "./StyleClassic.vue?vue&type=style&index=1&id=4ee09d61&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee09d61",
  null
  
)

export default component.exports